module.exports = __webpack_public_path__ + "img/AnnualMeeting2011LandscapePlan_1.a5baff39.png";